import React from 'react'
import { useRouter } from 'next/router'
import { useSolToUsdRate } from 'hooks/useSolToUsdRate'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// styles
import styles from './index.module.scss'

const ShopPhysicalCard = props => {
  const { data, onClick } = props
  const router = useRouter()
  const { solToUsdRate } = useSolToUsdRate()
  const handleCardClick = () => {
    if (onClick) {
      onClick(data)
    } else if (data.id) {
      router.push(`/merch/${data.id}`)
    }
  }

  return (
    <div className={styles.container} onClick={handleCardClick}>
      <div className={styles.imageArea}>
        <ImageWithFoster src={data.items[0].itemUrl} className="max-w-full max-h-full object-contain" />
      </div>
      <div className={styles.contentArea}>
        <div className={styles.username}>{data.creatorUsername || 'Username'}</div>
        <div className={styles.productName}>{data.items[0].itemName || 'Physical Name'}</div>
        <div className="w-full flex justify-center mt-[2px]">
          <div className="flex gap-[6px] items-center">
            <div className="w-[14px] h-[12px]">
              <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.9946 8.97L10.8386 11.222C10.7914 11.2713 10.7345 11.3105 10.6716 11.337C10.6083 11.3636 10.5403 11.3772 10.4716 11.377H0.253588C0.205045 11.377 0.157517 11.3631 0.116588 11.337C0.0761302 11.3111 0.0441474 11.2739 0.0245881 11.23C0.00395257 11.1871 -0.00336211 11.1391 0.0035881 11.092C0.0120396 11.0449 0.034319 11.0014 0.0675881 10.967L2.22859 8.715C2.27552 8.66578 2.33201 8.62664 2.39459 8.6C2.45783 8.57305 2.52585 8.5591 2.59459 8.559H12.8116C12.8601 8.55902 12.9077 8.5729 12.9486 8.599C12.989 8.62496 13.021 8.66215 13.0406 8.706C13.0601 8.74958 13.066 8.79801 13.0576 8.845C13.0494 8.89196 13.0274 8.93545 12.9946 8.97ZM10.8386 4.435C10.7914 4.38566 10.7345 4.34653 10.6716 4.32C10.6083 4.29339 10.5403 4.27979 10.4716 4.28H0.253588C0.205045 4.28002 0.157517 4.2939 0.116588 4.32C0.0761302 4.34592 0.0441474 4.38311 0.0245881 4.427C0.00395257 4.46987 -0.00336211 4.51794 0.0035881 4.565C0.0120972 4.61208 0.0343685 4.65558 0.0675881 4.69L2.22859 6.942C2.27562 6.99086 2.3321 7.02965 2.39459 7.056C2.45783 7.08295 2.52585 7.0969 2.59459 7.097H12.8116C12.8601 7.09698 12.9077 7.0831 12.9486 7.057C12.989 7.03104 13.021 6.99385 13.0406 6.95C13.0601 6.90642 13.066 6.85799 13.0576 6.811C13.0491 6.76392 13.0268 6.72042 12.9936 6.686L10.8386 4.435ZM0.253588 2.817H10.4726C10.5413 2.81721 10.6093 2.80361 10.6726 2.777C10.7355 2.75047 10.7924 2.71134 10.8396 2.662L12.9946 0.41C13.0278 0.375575 13.0501 0.332077 13.0586 0.285C13.067 0.23801 13.0611 0.18958 13.0416 0.146C13.0216 0.102348 12.9893 0.0655009 12.9486 0.04C12.9077 0.0138985 12.8601 2.15363e-05 12.8116 0L2.59359 0C2.52485 0.00010169 2.45683 0.0140455 2.39359 0.041C2.3311 0.0673487 2.27462 0.106135 2.22759 0.155L0.0715881 2.407C0.0368566 2.44087 0.0131566 2.48444 0.0035881 2.532C-0.00460807 2.57867 0.00131126 2.62672 0.0205881 2.67C0.0400973 2.71392 0.0720913 2.75113 0.112588 2.777C0.154661 2.80384 0.203686 2.81775 0.253588 2.817Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className={styles.price}>{(data.items[0].price / 100 / solToUsdRate).toFixed(2)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopPhysicalCard
